import { FC } from "react";
import Grid from "@mui/material/Grid";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumbs";
import CreditNote from '../../components/Invoice/CreditNote';
import DebitNote from '../../components/Invoice/DebitNote';

interface CreditNoteFormProps {
  type: string;
}

// Create/edit Estimate page
const CreditNoteForm: FC<CreditNoteFormProps> = ({type}) => {
  return (
    <>
      <BreadCrumb />
      <Grid rowSpacing="36" columnSpacing="22" container>
        <Grid item xs={12} md={12} lg={12}>
          {(type == 'sale-credit-note') ? <CreditNote type={type}/> : <DebitNote type={type}/> }
        </Grid>
      </Grid>
    </>
  );
};

export default CreditNoteForm;
